/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

/**
 * 查询的数据源。如果留空，将使用默认的数据库。如果设置为 `commercial`，将调用商业级API，返回更详细的地理位置信息，但响应时间可能会稍长。
 */
export const GetNetworkMyipSource = {
  Commercial: "commercial",
} as const;
/**
 * 查询的数据源。如果留空，将使用默认的数据库。如果设置为 `commercial`，将调用商业级API，返回更详细的地理位置信息，但响应时间可能会稍长。
 */
export type GetNetworkMyipSource = ClosedEnum<typeof GetNetworkMyipSource>;

export const GetNetworkMyipSource$zodSchema = z.enum([
  "commercial",
]).describe(
  "查询的数据源。如果留空，将使用默认的数据库。如果设置为 `commercial`，将调用商业级API，返回更详细的地理位置信息，但响应时间可能会稍长。",
);

export type GetNetworkMyipRequest = {
  source?: GetNetworkMyipSource | undefined;
};

export const GetNetworkMyipRequest$zodSchema: z.ZodType<GetNetworkMyipRequest> =
  z.object({
    source: GetNetworkMyipSource$zodSchema.optional(),
  });

export type GetNetworkMyipInternalServerErrorDetails = {};

export const GetNetworkMyipInternalServerErrorDetails$zodSchema: z.ZodType<
  GetNetworkMyipInternalServerErrorDetails
> = z.object({});

/**
 * 服务器内部错误。在查询IP归属地信息时发生错误。
 */
export type GetNetworkMyipInternalServerErrorResponseBody = {
  code?: string | undefined;
  details?: GetNetworkMyipInternalServerErrorDetails | undefined;
  message?: string | undefined;
};

export const GetNetworkMyipInternalServerErrorResponseBody$zodSchema: z.ZodType<
  GetNetworkMyipInternalServerErrorResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetNetworkMyipInternalServerErrorDetails$zodSchema)
    .optional(),
  message: z.string().optional(),
}).describe("服务器内部错误。在查询IP归属地信息时发生错误。");

export type GetNetworkMyipBadRequestDetails = {};

export const GetNetworkMyipBadRequestDetails$zodSchema: z.ZodType<
  GetNetworkMyipBadRequestDetails
> = z.object({});

/**
 * 无法获取有效的客户端IP。这在一些特殊的网络环境下可能发生，例如通过了复杂的代理。
 */
export type GetNetworkMyipBadRequestResponseBody = {
  code?: string | undefined;
  details?: GetNetworkMyipBadRequestDetails | undefined;
  message?: string | undefined;
};

export const GetNetworkMyipBadRequestResponseBody$zodSchema: z.ZodType<
  GetNetworkMyipBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetNetworkMyipBadRequestDetails$zodSchema).optional(),
  message: z.string().optional(),
}).describe(
  "无法获取有效的客户端IP。这在一些特殊的网络环境下可能发生，例如通过了复杂的代理。",
);

/**
 * 查询成功！返回你的客户端IP的详细信息。
 */
export type GetNetworkMyipResponseBody = {
  ip?: string | undefined;
  region?: string | undefined;
  isp?: string | undefined;
  llc?: string | undefined;
  asn?: string | undefined;
  latitude?: number | undefined;
  longitude?: number | undefined;
  beginip?: string | undefined;
  endip?: string | undefined;
  district?: string | undefined;
};

export const GetNetworkMyipResponseBody$zodSchema: z.ZodType<
  GetNetworkMyipResponseBody
> = z.object({
  asn: z.string().optional(),
  beginip: z.string().optional(),
  district: z.string().optional(),
  endip: z.string().optional(),
  ip: z.string().optional(),
  isp: z.string().optional(),
  latitude: z.number().optional(),
  llc: z.string().optional(),
  longitude: z.number().optional(),
  region: z.string().optional(),
}).describe("查询成功！返回你的客户端IP的详细信息。");

export type GetNetworkMyipResponse =
  | GetNetworkMyipResponseBody
  | GetNetworkMyipBadRequestResponseBody
  | GetNetworkMyipInternalServerErrorResponseBody;

export const GetNetworkMyipResponse$zodSchema: z.ZodType<
  GetNetworkMyipResponse
> = z.union([
  z.lazy(() => GetNetworkMyipResponseBody$zodSchema),
  z.lazy(() => GetNetworkMyipBadRequestResponseBody$zodSchema),
  z.lazy(() => GetNetworkMyipInternalServerErrorResponseBody$zodSchema),
]);
